import { Card, CardContent } from "@/components/ui/card";
import { Mail, Phone, User } from "lucide-react";

const committeeMembers = [
  { name: "Chris Hallendorff", position: "Commodore", order: 1 },
  { name: "Patrick Blennerhassett", position: "Vice Commodore", order: 2 },
  { name: "Vincent Chiappero", position: "Rear Commodore Racing", order: 3 },
  { name: "Robert Cunningham", position: "Rear Commodore Cruising", order: 4 },
  { name: "Denise Channer", position: "Secretary", order: 5 },
  { name: "Delaine Cunningham", position: "Treasurer", order: 6 },
  { name: "Werner Van Den Berg", position: "Safety Officer", order: 7 },
  { name: "Hendrik Britz", position: "Bosun", order: 8 },
  { name: "Peter Damhuis", position: "Ordinary Member", order: 9 },
  { name: "Willie Oosthuizen", position: "Ordinary Member", order: 10 },
  { name: "Francois Baart", position: "PRO", order: 11 },
  { name: "Peter Nichol", position: "Councillor", order: 12 },
  { name: "Judith Edwards", position: "Councillor", order: 13 }
];

export default function Committee() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="mb-6">
            <span className="inline-block px-4 py-2 rounded-full bg-sailing-gold/10 text-sailing-gold font-medium text-sm mb-4">
              2025/2026 Leadership Team
            </span>
          </div>
          <h1 className="text-5xl font-bold text-navy mb-6">Committee Members</h1>
        </div>

        {/* Top row: Commodore and Vice Commodore */}
        <div className="grid md:grid-cols-2 gap-8 mb-8 max-w-2xl mx-auto">
          {committeeMembers.slice(0, 2).map((member) => (
            <Card key={member.name} className="group hover:shadow-xl transition-all duration-300 border-0 shadow-lg bg-white rounded-2xl overflow-hidden">
              <CardContent className="p-8 text-center">
                <div className="relative mb-6">
                  <div className="w-32 h-32 mx-auto rounded-full bg-gradient-ocean overflow-hidden shadow-lg">
                    <div className="w-full h-full flex items-center justify-center bg-sailing-gold/20">
                      <User className="w-16 h-16 text-navy opacity-50" />
                    </div>
                  </div>
                </div>
                <h3 className="text-xl font-bold text-navy mb-2">{member.name}</h3>
                <div className="mb-4">
                  <span className="inline-block px-3 py-1 rounded-full bg-sailing-gold/10 text-sailing-gold font-medium text-sm">
                    {member.position}
                  </span>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Second row: Rear Commodores */}
        <div className="grid md:grid-cols-2 gap-8 mb-8 max-w-2xl mx-auto">
          {committeeMembers.slice(2, 4).map((member) => (
            <Card key={member.name} className="group hover:shadow-xl transition-all duration-300 border-0 shadow-lg bg-white rounded-2xl overflow-hidden">
              <CardContent className="p-8 text-center">
                <div className="relative mb-6">
                  <div className="w-32 h-32 mx-auto rounded-full bg-gradient-ocean overflow-hidden shadow-lg">
                    <div className="w-full h-full flex items-center justify-center bg-sailing-gold/20">
                      <User className="w-16 h-16 text-navy opacity-50" />
                    </div>
                  </div>
                </div>
                <h3 className="text-xl font-bold text-navy mb-2">{member.name}</h3>
                <div className="mb-4">
                  <span className="inline-block px-3 py-1 rounded-full bg-sailing-gold/10 text-sailing-gold font-medium text-sm">
                    {member.position}
                  </span>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Rest of committee */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {committeeMembers.slice(4).map((member) => (
            <Card key={member.name} className="group hover:shadow-xl transition-all duration-300 border-0 shadow-lg bg-white rounded-2xl overflow-hidden">
              <CardContent className="p-8 text-center">
                <div className="relative mb-6">
                  <div className="w-28 h-28 mx-auto rounded-full bg-gradient-ocean overflow-hidden shadow-lg">
                    <div className="w-full h-full flex items-center justify-center bg-sailing-gold/20">
                      <User className="w-12 h-12 text-navy opacity-50" />
                    </div>
                  </div>
                </div>
                <h3 className="text-lg font-bold text-navy mb-2">{member.name}</h3>
                <div className="mb-4">
                  <span className="inline-block px-3 py-1 rounded-full bg-sailing-gold/10 text-sailing-gold font-medium text-sm">
                    {member.position}
                  </span>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Contact Section */}
        <div className="bg-gradient-navy rounded-3xl p-12 text-white">
          <div className="text-center">
            <h2 className="text-3xl font-bold mb-6">Contact the Committee</h2>
            <p className="text-xl mb-8 text-gray-100">Have questions or suggestions? Our committee is here to help and values member input.</p>
            <div className="grid md:grid-cols-2 gap-8 max-w-2xl mx-auto">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6">
                <h3 className="font-bold mb-4 text-lg">General Inquiries</h3>
                <div className="flex items-center justify-center text-sailing-gold">
                  <Mail className="mr-3 h-5 w-5" />
                  <span className="font-medium">info@vaalcruising.co.za</span>
                </div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6">
                <h3 className="font-bold mb-4 text-lg">Phone Contact</h3>
                <div className="flex items-center justify-center text-sailing-gold">
                  <Phone className="mr-3 h-5 w-5" />
                  <span className="font-medium">083 446 9474</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}